import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function EditorialBand({
  image,
  kicker = "The Studio",
  title,
  caption,
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.12, 1.05, 1.12]);

  return (
    <section ref={ref} className="relative bg-[#121315] py-10 md:py-16 cv-auto">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="relative w-full h-[62vh] md:h-[82vh] overflow-hidden">
          <motion.img
            src={image}
            alt={title}
            loading="lazy"
            style={{ y, scale }}
            className="absolute inset-0 w-full h-[124%] object-cover"
          />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(18,19,21,0.25) 0%, rgba(18,19,21,0.05) 40%, rgba(18,19,21,0.7) 100%)" }} />
          <div className="absolute inset-4 md:inset-6 border border-[#F5F4F0]/15 pointer-events-none" />

          <div className="absolute left-8 md:left-14 bottom-10 md:bottom-14 max-w-2xl">
            <motion.p
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="text-[#F5F4F0] text-[11px] tracking-[0.4em] uppercase mb-5"
              style={{ textShadow: "0 2px 14px rgba(0,0,0,0.65)" }}
            >
              {kicker}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif-display text-[#F5F4F0] font-light tracking-tight text-3xl md:text-6xl leading-[1.02]"
              style={{ textShadow: "0 4px 40px rgba(0,0,0,0.5)" }}
            >
              {title}
            </motion.h2>
            {caption && (
              <motion.p
                initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
                transition={{ duration: 0.9, delay: 0.15 }}
                className="mt-5 text-[#EDE9E2]/85 text-sm md:text-base font-body max-w-md"
                style={{ textShadow: "0 2px 16px rgba(0,0,0,0.6)" }}
              >
                {caption}
              </motion.p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
